import { ReactNode } from 'react';
import useAuthStore from '../../stores/authStore';

interface TopbarProps {
	children?: ReactNode;
	showUserInfo?: boolean;
	onMenuClick?: () => void;
}

const Topbar = ({ children, showUserInfo = true, onMenuClick }: TopbarProps) => {
	const { user } = useAuthStore();

	return (
		<div className="min-h-[72px] flex flex-wrap items-center justify-between px-4 md:px-7 py-3 gap-3 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 transition-colors duration-300">
			<div className="flex gap-2 md:gap-3 items-center">
				{/* Hamburger Menu Button - Visible on all devices */}
				<button
					onClick={onMenuClick}
					className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors flex-shrink-0"
					aria-label="Toggle menu"
				>
					<svg className="w-6 h-6 text-gray-700 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
					</svg>
				</button>
				{children}
			</div>

			{showUserInfo && user && (
				<div className="flex gap-3 items-center">
					<div className="font-semibold text-gray-900 dark:text-gray-100 text-sm md:text-base">
						{user.role === 'SUPER_ADMIN'
							? 'Super Admin'
							: user.role === 'SALON_OWNER'
								? 'Salon Owner'
								: user.role === 'MANAGER'
									? 'Manager'
									: 'Staff'}
					</div>
				</div>
			)}
		</div>
	);
};

export default Topbar;
